import React from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import { InputNumber, Text, Switch, SwitchSizes } from '@clockout-dev/design-elements';
import styles from '../styles/accessRulesCard.module.scss';

function AccessRuleCard({ title, prefix, suffix, days, enabled, readOnly = false, onToggle, onChangeDays }) {
    const controlsDisabled = readOnly || !enabled;

    return (
        <div className={`${styles.ruleCard} ${enabled && !readOnly ? '' : styles.ruleCardDisabled}`}>
            <div className={styles.ruleHeader}>
                <div className={styles.ruleHeaderLeft}>
                    <span className={styles.ruleIcon} aria-hidden="true">
                        <CalendarOutlined />
                    </span>
                    <Text as="span" size="s" className={styles.ruleTitle}>
                        {title}
                    </Text>
                </div>
                <Switch
                    checked={!!enabled}
                    onChange={readOnly ? undefined : onToggle}
                    disabled={readOnly}
                    size={SwitchSizes.SMALL}
                    classNames={{ switch: styles.ruleSwitch }}
                />
            </div>
            <div className={styles.ruleBody} aria-disabled={controlsDisabled || undefined}>
                <Text as="span" size="s" className={styles.ruleText}>
                    {prefix}
                </Text>
                <InputNumber
                    value={days}
                    onChange={onChangeDays}
                    disabled={controlsDisabled}
                    min={0}
                    max={999}
                    step={1}
                    precision={0}
                    controls={false}
                    className={`${styles.ruleDaysInput}`}
                />
                <Text as="span" size="s" className={styles.ruleText}>
                    {suffix}
                </Text>
            </div>
        </div>
    );
}

export default AccessRuleCard;
